// extracted by mini-css-extract-plugin
export var leftAlign = "_2y-2";
export var popper = "_2y-0";
export var subtitle = "_2y-1";